import { render, staticRenderFns } from "./taohuali.vue?vue&type=template&id=30677950&scoped=true"
import script from "./taohuali.vue?vue&type=script&lang=js"
export * from "./taohuali.vue?vue&type=script&lang=js"
import style0 from "./taohuali.vue?vue&type=style&index=0&id=30677950&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30677950",
  null
  
)

export default component.exports